import { svgIcon } from "../icon-service";

export const WebAuthnIcon = svgIcon`
 <svg
    xmlns="http://www.w3.org/2000/svg"
    width="62.176998"
    height="60.152"
    fill="none"
    class="tw-text-primary-600"
    role="img"
    aria-label="[title]"
  >
    <title>Webauthn</title>
    <g stroke="currentColor" clip-path="url(#webauthn-clip)" transform="translate(-6.081,-1.143)">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        stroke-width="2"
        d="M20.418 33.19c5.614 0 10.42 3.56 12.396 8.533h29.012l5.434 5.522-4.491 4.563h-6.602l-3.413-3.468-3.279 3.24-1.167-1.187-1.303 1.323-3.188-3.24-3.1 3.149H32.86c-1.932 5.065-6.782 8.67-12.44 8.67-7.366 0-13.339-6.069-13.339-13.553 0-7.483 5.928-13.552 13.338-13.552Zm-6.152 16.975c1.841 0 3.368-1.506 3.368-3.422 0-1.871-1.482-3.423-3.368-3.423-1.887 0-3.369 1.506-3.369 3.422 0 1.917 1.527 3.423 3.369 3.423Z"
      />
      <path
        stroke-linecap="round"
        d="M59.78 44.722H36.32M19.99 36.722c4.036 0 7.569 2.405 9.51 6"
      />
      <circle
        cx="12.24"
        cy="12.24"
        r="12.24"
        stroke-width="2"
        transform="matrix(-1 0 0 1 50.6 2.143)"
      />
      <path
        stroke-width="2"
        d="M22.753 33.423c3.836-4.174 9.41-6.8 15.615-6.8 9.698 0 17.857 6.417 20.243 15.13"
      />
    </g>
    <defs>
      <clipPath id="webauthn-clip"><path fill="#fff" d="M68.5.62H.5v61h68z" /></clipPath>
    </defs>
  </svg>
`;
